export enum UserRightsTypes {
    Admin = 'Admin',
    User = 'User',
    Creator = 'Creator',
    Anonymous = 'Anonymous',
    Channel = 'Channel',
    BindedChannel = 'BindedChannel',
    Bot = 'Bot',
}